import React, { ReactNode } from 'react';
import Auth0Provider from './Auth0Provider';
import AuthentikProvider from './AuthentikProvider';

// VITE_AUTH_PROVIDER is replaced with a literal string at build time by Vite.
// The unused branch is dead code and tree-shaken away.
const AUTH_PROVIDER = import.meta.env.VITE_AUTH_PROVIDER || 'auth0';

interface AuthProviderProps {
  children: ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  if (AUTH_PROVIDER === 'authentik') {
    return <AuthentikProvider>{children}</AuthentikProvider>;
  }
  return <Auth0Provider>{children}</Auth0Provider>;
};

export default AuthProvider;
